import produce from 'immer'

const initialState = {
  // newest notifs first
  items: [],
  isOpen: false,
}

const notifications = produce((draft = initialState, action) => {
  switch (action.type) {
    case 'NOTIFICATIONS_PUSH': {
      const existingIndex = draft.items.findIndex(n => n.id === action.payload.id)
      if (existingIndex === -1) {
        draft.items.unshift(action.payload)
      } else {
        // replace a notification sharing the same id rather than duplicating it.
        draft.items[existingIndex] = action.payload
      }
      return draft
    }
    case 'NOTIFICATIONS_DISMISS':
      draft.items = draft.items.filter(n => n.id !== action.payload)
      return draft
    case 'NOTIFICATIONS_DISMISS_ALL':
      draft.items = []
      return draft
    case 'NOTIFICATIONS_MARK_READ': {
      const notification = draft.items.find(n => n.id === action.payload)
      if (notification) {
        notification.read = true
      }
      return draft
    }
    case 'NOTIFICATIONS_MARK_ALL_READ':
      draft.items.forEach(n => { n.read = true })
      return draft
    case 'NOTIFICATIONS_OPEN':
      draft.isOpen = true
      return draft
    case 'NOTIFICATIONS_CLOSE':
      draft.isOpen = false
      return draft
    case 'NOTIFICATIONS_TOGGLE':
      draft.isOpen = !draft.isOpen
      return draft
    default:
      return draft
  }
})

export default notifications
